import React from 'react';

const AddressForm = ({ address, onAddressChange }) => {
  return (
    <div className="address-form-section">
      <h3>Dirección de Domicilio</h3>
      <input
        type="text"
        placeholder="Ingresa tu dirección"
        value={address}
        onChange={(e) => onAddressChange(e.target.value)}
      />
    </div>
  );
};

export default AddressForm;
